import React from "react";
import { T, SERIF, FAMILY, FONT, GOLD_INK } from "../theme/tokens.js";
import { APP_NAME } from "../config.js";
import { Wordmark } from "../components/ui/index.jsx";

/* "Which contract are you working in?" Shown after sign-in whenever a user
   can reach more than one contract. Everything they then see and enter
   belongs to the context chosen here. Members never get a combined view;
   only admins get the portfolio option. */
export default function ContractPicker({ contracts, isAdmin, firstName, onChoose, onSignOut }) {
  return (
    <div style={{
      minHeight: "100vh", background: T.navy, display: "flex",
      alignItems: "center", justifyContent: "center", fontFamily: FAMILY, padding: 16,
    }}>
      <style>{FONT}</style>
      <div style={{
        background: T.panel, border: `1px solid ${T.line}`,
        borderTop: `4px solid ${T.gold}`, borderRadius: 6, padding: 32,
        width: "100%", maxWidth: 460,
      }}>
        <Wordmark onLight />
        <div style={{
          fontSize: 10.5, fontWeight: 700, letterSpacing: "0.14em",
          textTransform: "uppercase", color: GOLD_INK, margin: "12px 0 4px",
        }}>{APP_NAME}</div>

        <div style={{ fontFamily: SERIF, fontSize: 17, fontWeight: 700, color: T.ink, margin: "14px 0 4px" }}>
          Welcome, {firstName}. Which contract are you working in?
        </div>
        <div style={{ fontSize: 13, color: T.soft, marginBottom: 16 }}>
          Everything you view and enter goes to the contract you choose. You can
          switch anytime from the top bar.
        </div>

        <div style={{ display: "grid", gap: 8 }}>
          {contracts.map((c) => (
            <button
              key={c.id}
              onClick={() => onChoose(c.id)}
              style={{
                textAlign: "left", padding: "13px 15px", border: `1px solid ${T.line}`,
                borderLeft: `4px solid ${T.navy}`, borderRadius: 4, background: "#fff", cursor: "pointer",
              }}
            >
              <div style={{ fontSize: 15, fontWeight: 700, color: T.navy }}>{c.name}</div>
              <div style={{ fontSize: 12.5, color: T.soft }}>
                {c.client || ""}{c.contract_number ? ` · ${c.contract_number}` : ""}
              </div>
            </button>
          ))}

          {isAdmin && (
            <button
              onClick={() => onChoose("all")}
              style={{
                textAlign: "left", padding: "13px 15px", border: `1px solid ${T.line}`,
                borderLeft: `4px solid ${T.gold}`, borderRadius: 4, background: T.chip, cursor: "pointer",
              }}
            >
              <div style={{ fontSize: 15, fontWeight: 700, color: T.navy }}>All contracts (portfolio view)</div>
              <div style={{ fontSize: 12.5, color: T.soft }}>Executive overview across every program</div>
            </button>
          )}
        </div>

        <button
          onClick={onSignOut}
          style={{ background: "none", border: "none", color: T.soft, fontSize: 12.5, cursor: "pointer", padding: 0, marginTop: 16 }}
        >Sign out</button>
      </div>
    </div>
  );
}
